export default "__VITE_ASSET__Dwhk_6Ra__"